import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

import { AgentRowAvatar } from '@confluence/agent-user-dual-avatar/entry-points/AgentRowAvatar.ts';
import { AgentUserDualAvatar } from '@confluence/agent-user-dual-avatar/entry-points/AgentUserDualAvatar.ts';
import { useAgentAvatarColorMode } from '@confluence/agent-user-dual-avatar/entry-points/useAgentAvatarColorMode.ts';

import type { RankedPagePersonOrAgent } from '../../utils/rankPagePeopleAndAgents.ts';

export const PersonListAvatar = ({
	personOrAgent,
}: {
	personOrAgent: RankedPagePersonOrAgent;
}): React.JSX.Element => {
	const colorMode = useAgentAvatarColorMode();
	const { agent, name, picture } = personOrAgent;
	const attributedUser = agent?.attributedUser;
	let avatar: React.JSX.Element;

	if (!agent) {
		avatar = <Avatar src={picture ?? undefined} name={name} size="medium" />;
	} else if (attributedUser?.name.trim()) {
		// Identity IDs would add profile-card actions to these decorative avatars.
		avatar = (
			<AgentUserDualAvatar
				agentName={name}
				agentAvatarUrl={picture ?? undefined}
				agentIcon={agent.agentIcon}
				userName={attributedUser.name}
				userAvatarUrl={attributedUser.avatarURL || undefined}
				size="large"
				colorMode={colorMode}
			/>
		);
	} else {
		avatar = (
			<AgentRowAvatar
				name={name}
				avatarUrl={picture ?? undefined}
				agentIcon={agent.agentIcon}
				avatarSize="medium"
				hasInlineSpacing={false}
				colorMode={colorMode}
			/>
		);
	}

	// The row already supplies the accessible name; Avatar still needs name for initials.
	return <span aria-hidden="true">{avatar}</span>;
};
